import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import axios from "../axios/axios";
import { Link, useNavigate } from "react-router-dom";

export default function Profile() {
  const navigate = useNavigate();

  const token = Cookies.get("auth_token");
  const [user, setUser] = useState({});
  const [cv, setCv] = useState({});
  const [jours, setJours] = useState("");
  const [mois, setMois] = useState("");
  const [annees, setAnnees] = useState("");
  const [chargement, setChargement] = useState(false);

  useEffect(() => {
    profileDetails();
  }, []);

  const profileDetails = () => {
    setChargement(true);
    axios
      .get("/profile", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setUser(response.data.user);
        setCv(response.data.cv);
        setJours(response.data.day);
        setMois(response.data.months);
        setAnnees(response.data.years);
        setChargement(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const completerCv = (e) => {
    Cookies.remove("idoffre");
    navigate(`${process.env.PUBLIC_URL}/completer-voter-cv`);
  };

  const editeCV = (e) => {
    Cookies.remove("addPJ");
    Cookies.remove("idoffre");
    navigate(`${process.env.PUBLIC_URL}/modifier-cv/${cv.id}`);
  };

  return (
    <>
      {chargement == true ? (
        <div className="container card text-center mt-5">
          <h4>Chargement .... </h4>
        </div>
      ) : (
        <div className="container card ctn-profile mt-3">
          <div className="row">
            <div className="col-sm-2 text-center">
              {cv != null && cv.photo != null ? (
                <img
                  className="img-fluid"
                  src={
                    process.env.NODE_ENV === "production"
                      ? process.env.REACT_APP_API_BASE_URL_PROD +
                        `/storage/images/${cv.photo}`
                      : process.env.REACT_APP_API_BASE_URL_LOCAL +
                        `/storage/images/${cv.photo}`
                  }
                  alt="image"
                  style={{ fontSize: "100x", width: "auto", height: "150px" }}
                />
              ) : (
                <img
                  className="profile-image img-fluid"
                  src={`${process.env.PUBLIC_URL}/images/profile.jpg`}
                  alt="Profile"
                />
              )}

              <p>
                <b>{cv != null ? <span>#{cv.id}</span> : null}</b>
              </p>
            </div>
            <div className="col-sm-5 line-right-profile">
              <p className="p" style={{ fontSize: "20px", fontWeight: "bold" }}>
                {cv != null ? cv.nom : user.name}
              </p>
              <p className="p" style={{ fontSize: "15px", fontWeight: "bold" }}>
                {cv != null ? cv.niveau : null}
              </p>
              <p className="p">{cv != null ? cv.domain_d_etude : null}</p>
              {cv != null ? (
                <p className="p">
                  {annees > 0 ? <span> {annees} ans </span> : null}
                  {mois > 0 ? <span> {mois} mois </span> : null}
                  d'experiences
                </p>
              ) : null}
            </div>
            <div className="col-sm-5">
              <div className="profile-right">
                <div>
                  {cv != null ? (
                    <>
                      <p className="p">
                        <Link
                          className="link link-profile"
                          to={`${process.env.PUBLIC_URL}/consulter-voter-cv`}
                        >
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="arrow-in-profile"
                          />
                          Consulter mon CV
                        </Link>
                      </p>
                      <p className="p">
                        <a
                          className="link link-profile"
                          onClick={editeCV}
                          style={{ cursor: "pointer" }}
                        >
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="arrow-in-profile"
                          />
                          Mettre à jour mon Cv
                        </a>
                      </p>
                      <p className="p">
                        <Link
                          className="link link-profile"
                          to={`${process.env.PUBLIC_URL}/mes-candidatures`}
                        >
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="arrow-in-profile"
                          />
                          Consulter mes candidatures
                        </Link>
                      </p>
                      <p className="p">
                        <Link
                          className="link link-profile"
                          to="https://www.rimtic.com/modelesLettres"
                        >
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="arrow-in-profile"
                          />
                          Letteres de motivation modèles
                        </Link>
                      </p>
                    </>
                  ) : (
                    <p className="p">
                      <a
                        className="link link-profile"
                        onClick={completerCv}
                        style={{ cursor: "pointer" }}
                      >
                        <FontAwesomeIcon
                          icon={faArrowRight}
                          className="arrow-in-profile"
                        />
                        Completer mon Cv
                      </a>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
